import { Outlet } from "react-router-dom"
const MainTaskss = () =>{

    return(
        <div className=" w-full h-full">
         <Outlet/>
        </div>
    )
}


export default MainTaskss;